export default __webpack_public_path__ + "static/media/finboxDark.c9182d66.svg";